module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_html.js
// module id = 243
// module chunks = 2